module.exports = __webpack_public_path__ + "static/media/gmap_image.12c3ba96.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gmap_image.png
// module id = 74
// module chunks = 0